//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { CHAT_DISABLED_REASON } from './chatPanelId';
import { useLLM } from '@/hooks/useLLM';

interface ChatAvailability {
  readonly isDisabled: boolean;
  readonly disabledReason: string;
}

/**
 * Whether the chat panel is usable right now. Chat is the one tool that needs
 * a configured model, and its two launchers -- the taskbar pill and the
 * mobile header's own -- must agree on the same answer, so both read it from
 * here rather than each subscribing to `useLLM()` on its own.
 */
export const useChatAvailability = (): ChatAvailability => {
  const { activeLLM } = useLLM();
  return { isDisabled: !activeLLM, disabledReason: CHAT_DISABLED_REASON };
};
